import * as React from "react";
import { useTheme } from "@mui/material/styles";

const FilterIcon = (props) => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.8773 0.0708147H2.00162C0.987221 0.0708147 0.164062 0.893973 0.164062 1.90837C0.164062 2.34905 0.322042 2.7731 0.604743 3.10569L4.90346 8.11948C5.06144 8.31071 5.1529 8.55184 5.1529 8.79297V13.4825C5.1529 13.9897 5.41066 14.4553 5.84302 14.7214C6.07584 14.8627 6.34191 14.9376 6.60798 14.9376C6.83248 14.9376 7.04866 14.8877 7.25653 14.7796L8.91948 13.9481C9.41836 13.6987 9.726 13.1998 9.726 12.6427V8.78465C9.726 8.53521 9.81747 8.29409 9.97545 8.11116L14.2742 3.09738C14.5569 2.76479 14.7148 2.34074 14.7148 1.90006C14.7148 0.885658 13.8917 0.0625 12.8773 0.0625V0.0708147ZM13.3263 2.29085L9.02757 7.30463C8.67003 7.72037 8.4788 8.2442 8.4788 8.79297V12.651C8.4788 12.7342 8.43722 12.8007 8.36239 12.8339L6.69944 13.6654C6.60798 13.7153 6.53315 13.682 6.49989 13.6571C6.46663 13.6321 6.40011 13.5823 6.40011 13.4825V8.79297C6.40011 8.2442 6.20887 7.72037 5.85134 7.30463L1.55262 2.29085C1.46116 2.18276 1.41127 2.04972 1.41127 1.90837C1.41127 1.5841 1.67734 1.31802 2.00162 1.31802H12.8773C13.2016 1.31802 13.4676 1.5841 13.4676 1.90837C13.4676 2.04972 13.4177 2.18276 13.3263 2.29085Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default FilterIcon;
